@if (buildingState$ | async; as buildingState) {
    @switch (buildingState.status) {
        @case ('success') {
            <div class="container-fluid">
                <h1 class="my-0 lh-1">{{ heading$ | async }}</h1>
                <p class="my-0 lh-1 text-secondary">
                    {{ 'common_system' | translate }} {{ buildingState.buildingNo }}
                    @if (buildingState.buildingDetails.building.buildingName; as buildingName) {
                        {{ buildingName }}
                    }
                    <button class="btn btn-text-primary py-0" (click)="changeBuilding()">
                        {{ 'actions_changeSystem' | translate: 'online' : 'common' }}
                    </button>
                </p>
            </div>

            <ul class="nav nav-tabs justify-content-start">
                @for (tab of tabs$ | async; track tab) {
                    <li class="nav-item">
                        <a class="nav-link" routerLinkActive="active" [routerLink]="tab.route">
                            {{ tab.text }}
                        </a>
                    </li>
                }
            </ul>

            <router-outlet />
        }
        @case ('pending') {
            Building is pending. This should not happen.
        }
        @case ('loading') {
            <app-load />
        }
        @case ('error') {
            <div class="container-fluid mt-3">
                {{ 'ERROR_ERROR_OCCURRED' | translate: 'online' : 'common' }}
            </div>
        }
    }
}
